import React from 'react';
import { MyAccessibleDoctor } from '../../../bridge/types/doctorProfile';

const DoctorTile = ({
    isSelected = false,
    doctor,
    onClick,
}: {
    isSelected: boolean;
    doctor: MyAccessibleDoctor;
    onClick: () => void;
}): JSX.Element => {
    return (
        <button
            onClick={onClick}
            className={`cursor-pointer w-full flex items-center space-x-8 py-8 px-16 ${
                isSelected ? 'dr-bg-darwin-primary-bg-light' : 'hover:bg-darwin-neutral-50'
            }`}
        >
            <img
                className="w-36 h-36 rounded-full"
                src={
                    doctor.personal.pic ||
                    'https://cdn.eka.care/vagus/cl2rhhut3000l0sg1fkcghr9j.png'
                }
                alt={doctor.personal.name.f}
            />
            <div className="dr-line-clamp-1">{doctor.personal.name.f}</div>
        </button>
    );
};

export default DoctorTile;
